var React = require('react');

function FbIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"XMLID_17_","transform":"translate(-67.5 -67.5)"},[React.createElement("path",{"id":"XMLID_22_","d":"M121.5,94.5a27,27,0,1,0-31.216,26.675V102.312h-6.85V94.5h6.85V88.553c0-6.761,4.024-10.5,10.193-10.5a41.192,41.192,0,0,1,6.051.533v6.643h-3.4c-3.358,0-4.394,2.086-4.394,4.216V94.5h7.486l-1.2,7.812H98.731v18.863A27,27,0,0,0,121.5,94.5Z","fill":"#1877f2","key":0}),React.createElement("path",{"id":"XMLID_18_","d":"M196.685,163.063l1.2-7.812H190.4v-5.06c0-2.13,1.05-4.216,4.394-4.216h3.4v-6.643a41.191,41.191,0,0,0-6.051-.533c-6.169,0-10.193,3.743-10.193,10.5v5.947H175.1v7.812h6.85v18.863a26.441,26.441,0,0,0,4.216.325,28.283,28.283,0,0,0,4.216-.325V163.063Z","transform":"translate(-91.681 -60.751)","fill":"#fff","key":1})]));
}

FbIconInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54"};

module.exports = FbIconInline;

FbIconInline.default = FbIconInline;
